import { render } from "./ReturnPortalSuccess.vue?vue&type=template&id=3d108202"
import script from "./ReturnPortalSuccess.vue?vue&type=script&lang=js"
export * from "./ReturnPortalSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__